import React from 'react'

const Footer = ({ onOpenFeedback, onOpenQuery }) => {
  return (
    <footer>
        <div className="footers">
            <p className="opens-modal feedback-cta" onClick={onOpenFeedback}>Make this game better. Share your thoughts here</p>
            <p className="opens-modal help-cta" onClick={onOpenQuery}>Need help? Reach out to us here</p>
        </div>
    </footer>
  )
}

export default Footer